import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';

interface HelpContextData {
  helpData: any;
  setDataHelp: (item: any) => void;
}

interface HelpProviderProps {
  children: ReactNode;
}

export const HelpContext = createContext({} as HelpContextData);

function HelpProvider({ children }: HelpProviderProps) {
  const [helpData, setHelpData] = useState<any>();

  function setDataHelp(item: any) {
    setHelpData(item);
  }

  return (
    <HelpContext.Provider
      value={{
        helpData,
        setDataHelp,
      }}
    >
      {children}
    </HelpContext.Provider>
  );
}

function useHelp() {
  const context = useContext(HelpContext);
  if (context === undefined) {
    throw new Error('useWebsocket must be used within a WebsocketProvider');
  }
  return context;
}

export { HelpProvider, useHelp };
